import React from "react";

import { formatMoney } from "../../components/shared/Utils";

import { CheckoutTypes } from "../../models/CheckoutTypes";
import OrderSummaryItem from "./OrderSummaryItem";
import Loader from '../../components/shared/Loader';
import { hasRequiredErrors } from "./CheckoutUtils";

const OrderSummary = (props) => {
    const {
        items,
        paymentModel,
        step,
        isCheckoutFetching,
        completeOrder,
        inProgress,
        backToCart,
        checkoutCommonFields,
        retrySubmit,
    } = props;

    //const [inProgress, setInProgress] = useState(false);

    const calcTotal = () => {
        return items.reduce((acc, val) => acc + val.Amount * val.PricePerUnit, 0);
    }

    return (
        <React.Fragment>
            <div className="d-lg-block collapse show" id="collapseExample">
                <div className="summary-title mb-2">
                    <div>
                        <h3>Order Summary</h3>
                    </div>
                    <div className="navigation back-to-cart">
                        <button className="btn btn-link" onClick={backToCart}>Back to Cart</button>
                    </div>
                </div>
                {
                    items.map((item, i) => {
                        return (
                            <OrderSummaryItem
                                item={item}
                                key={item.ProductNumber + "_" + i} />
                        );
                    })
                }
                {
                    (step === CheckoutTypes.INFO || step === CheckoutTypes.REVIEW) &&
                    <div className="sum-total d-flex">
                        <div className="mb-2">Total</div>
                            <div className="flex-grow-1 text-right mb-2">
                                <strong>{formatMoney(calcTotal())}</strong>
                        </div>
                    </div>
                }
            </div>
            {checkoutCommonFields && checkoutCommonFields.length > 0 &&
                step === CheckoutTypes.REVIEW &&
                <div className="d-lg-block">
                    <button disabled={isCheckoutFetching || inProgress || hasRequiredErrors(checkoutCommonFields)} type="button" className="btn btn-primary ml-sm-auto w-100 d-none d-lg-block"
                        onClick={(e) => {completeOrder(paymentModel); }}>
                        Place Order Now
                    </button>
                    {(isCheckoutFetching || inProgress) && <Loader />}
                </div>
            }
            {
                step === CheckoutTypes.ORDERSUBMITTED && retrySubmit &&
                <div className="d-lg-block">
                    <button disabled={isCheckoutFetching || inProgress || hasRequiredErrors(checkoutCommonFields)} type="button" className="btn btn-primary ml-sm-auto w-100 d-none d-lg-block"
                        onClick={(e) => {completeOrder(paymentModel); }}>
                        Place Order Now
                    </button>
                    {(isCheckoutFetching || inProgress) && <Loader />}
                </div>
            }
        </React.Fragment>
    )
}

export default OrderSummary;